import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQSection = () => {
  const faqs = [
    {
      question: "Are you financial advisors?",
      answer: "No. ICS is strictly an educational research community. We share analysis and opinions, but we do not provide personalized financial advice, investment recommendations, or manage anyone's money. Members should consult qualified professionals for financial advice.",
    },
    {
      question: "Do you manage money or execute trades?",
      answer: "No. We do not manage funds, execute trades, or act as brokers in any capacity. Members trade independently through their own brokerage accounts and are solely responsible for their investment decisions.",
    },
    {
      question: "Is every idea 100% guaranteed to be Shariah-compliant?",
      answer: "We do our best to apply recognized Shariah screening criteria to our research. However, we are not qualified Islamic scholars, and compliance determinations can vary. Members should always perform their own independent checks and consult with qualified scholars if needed.",
    },
    {
      question: "How do I join the paid Inner Circle?",
      answer: "Join our Inner Circle through our Patreon page at patreon.com/c/ics_shariah. This gives you full access to all Discord channels, research write-ups, and exclusive community features.",
    },
    {
      question: "What markets do you cover?",
      answer: "We focus primarily on US equities and Pakistan Stock Exchange (PSX) listed companies, along with periodic coverage of commodities like gold and oil. This focused approach allows for deeper research rather than shallow coverage of many markets.",
    },
    {
      question: "How often is new research published?",
      answer: "Research frequency varies based on community activity and market conditions. Inner Circle members typically receive multiple write-ups per month, plus ongoing discussions and quick takes in Discord channels.",
    },
  ];

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 md:py-32 bg-ics-navy"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="section-divider mx-auto" />
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-ics-white mb-4">
            Frequently Asked Questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`faq-${index}`}
              data-testid={`faq-item-${index}`}
              className="glass-card rounded-xl px-6 border-none"
            >
              <AccordionTrigger className="faq-trigger text-left text-ics-white hover:text-ics-orange py-5 text-base font-medium hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-ics-gray pb-5 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
